import { render, staticRenderFns } from "./SurplusRequests.html?vue&type=template&id=f5e51662&external"
import script from "./SurplusRequests.js?vue&type=script&lang=js&external"
export * from "./SurplusRequests.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports